<section
  id="login-content"
  customerScreenType
  class="s-full fx-row fx-center">
  <customer-azzurro-inverter
    customerScreenType
    id="login-welcome"
    class="s-full overflow-auto">
  </customer-azzurro-inverter>
  <section class="h-full w-3p min-w-100">
    <app-login
      customerScreenType
      class="w-full">
      <div
        anotherSignUps
        class="mb-5 w-full">
        <div
          *ngIf="emulator"
          class="fx-row mx-3 p-1 fx-gap-2">
          <customer-simple-input
            class="fx-g-1"
            placeholder="Custom Token"
            data-testid="login-custom-token-input"
            [input]="token">
          </customer-simple-input>
          <customer-simple-button
            data-testid="login-custom-token-submit"
            [label]="'i18n.common.login' | translate"
            [action]="loginWithCustomToken">
          </customer-simple-button>
        </div>

        <div class="fx-row fx-align-center fx-justify-center">
          <hr class="fx-g-1 bg-grey-300 mx-5">
          Or
          <hr class="fx-g-1 bg-grey-300 mx-5">
        </div>

        <button
          *ngIf="isSignWithAppleAvailable"
          type="button"
          class="fx-row fx-center fx-gap-3 my-3 h-9 w-11p mx-auto radius-4 bg-black text-white tw-font-normal tw-text-base shadow-3"
          [disabled]="inCorse"
          (click)="signUpWithApple()"
          (keyup.enter)="$event.preventDefault()">
          <img
            class="mr-2 s-6"
            src="assets/images/svg/apple.svg"
            alt="Apple Logo">
          {{ 'i18n.LoginService.signInWithApple' | translate }}
        </button>

        <button
          type="button"
          class="fx-row fx-center fx-gap-3 my-3 h-9 w-11p mx-auto radius-4 bg-grey-100 text-grey-400 tw-font-normal tw-text-base shadow-3"
          [disabled]="inCorse"
          (click)="signUpWithGoogleWeb()"
          (keyup.enter)="$event.preventDefault()">
          <img
            class="mr-2 s-6"
            src="assets/images/svg/google.svg"
            alt="Google Logo">
          <span class="tw-capitalize tw-text-base">
            {{ 'i18n.LoginService.signInWithGoogle' | translate }}
          </span>
        </button>

      </div>
    </app-login>
  </section>
</section>
